function AbstractIframe(props) {
  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <iframe
        src={props.url + `token=${localStorage.getItem("token")}`}
        title="iframe"
        style={{
          flex: 1,
          width: "97.95%",
          marginLeft: "22px",
          minHeight: 0,
          border: 0,
        }}
        sandbox="allow-scripts allow-same-origin allow-downloads allow-forms allow-top-navigation-by-user-activation allow-popups allow-popups-to-escape-sandbox allow-modals"
      />
    </div>
  );
}

export default AbstractIframe;
